import { Router } from '@angular/router';
import { Localization } from '../../Localization';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/service/auth.service';
import { HeaderService } from 'src/app/shared/services/header.service';
import { EnclosuresService } from 'src/app/enclosures/services/enclosures.service';
import { Subscription } from 'rxjs';
import { AppPageTexts, getAppTexts } from 'src/app/shared/i18n/app-text';
import {
  AppLanguage,
  LanguageService,
} from 'src/app/shared/services/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() nameHeader: string;
  idUser: any;
  idAdmin: any;

  public focus;
  public location: Location;
  error: any;
  onlyEnclosures: any = [];
  image: any;
  color: any;
  style: any;
  nameProfile = '';
  state = 'Monterrey, N.L.';
  readonly defaultImage: string = 'assets/img/ParkitHeader.png';
  private headerImageSub: Subscription;
  private hasSetDefaultImage = false;
  currentLang: AppLanguage = 'es';
  texts: AppPageTexts<'header'> = getAppTexts('header', 'es');

  constructor(
    private router: Router,
    public readonly localization: Localization,
    private authenticationService: AuthService,
    private readonly headerService: HeaderService,
    private readonly enclosuresService: EnclosuresService,
    private readonly languageService: LanguageService
  ) {
    if (localStorage.getItem('idAdmin') == null) {
      this.authenticationService.currentUser.subscribe(
        (currentUser) =>
          (this.idAdmin =
            currentUser != null ? currentUser.response.intFKIDUsuario : 0)
      );
    } else {
      this.idAdmin = Number(localStorage.getItem('idAdmin'));
    }
    if (this.idAdmin !== 1) {
      localStorage.setItem('idAdmin', JSON.stringify(this.idAdmin));
    }
  }

  ngOnInit(): void {
    this.languageService.currentLang$.subscribe((language) => {
      this.currentLang = language;
      this.texts = getAppTexts('header', language);
      this.updateHeaderTitle();
    });

    this.headerImageSub = this.headerService.headerImage$.subscribe((src) => {
      if (src) {
        this.image = src;
      }
    });

    this.authenticationService.currentUser.subscribe(
      (currentUser) => {
        this.idUser =
          currentUser != null ? currentUser.response.intFKIDProfile : 0;
        this.nameProfile =
          currentUser != null ? currentUser.response.chrNombreUsuario : '';
        this.updateHeaderTitle();
      }
    );

    this.listOnlyEnclosuresByAdmin();
  }

  private updateHeaderTitle(): void {
    if (this.idUser === 1) {
      this.nameHeader = this.texts.home;
    }
    if (this.idUser === 2) {
      if (this.idAdmin === 1) {
        this.nameHeader = this.texts.selectEnclosure;
      } else {
        this.nameHeader = this.texts.buyParkingSpot;
      }
    }
    if (this.idUser === 3) {
      this.nameHeader = this.texts.home;
    }
    if (this.idAdmin === 5) {
      this.nameHeader = this.texts.prepaid;
    }

    if (this.router.url.includes('/locality')) {
      this.nameHeader = '';
    }
  }

  ngOnDestroy(): void {
    if (this.headerImageSub) {
      this.headerImageSub.unsubscribe();
    }
  }

  listOnlyEnclosuresByAdmin(): void {
    if (this.idAdmin === 1) {
      this.image = this.defaultImage;
      this.style = '#031E3A';
    } else {
      const idAdmin = localStorage.getItem('idAdmin');
      const idRecinto = localStorage.getItem('idRecinto');
      this.enclosuresService.getEnclosureByAdminAndRecinto(idAdmin, idRecinto).subscribe(
        (data) => {
          const raw = data?.response ?? {};
          const item: any = {
            ...raw,
            idAdmin: raw.intFKIdAdmin ?? raw.idAdmin,
          };
          if (item && item.idAdmin !== undefined && item.idAdmin !== null) {
            this.idAdmin = item.idAdmin;
            localStorage.setItem('idAdmin', JSON.stringify(this.idAdmin));
          }
          const rawHeader = item.photoHeader;
          const headerStr =
            rawHeader !== undefined && rawHeader !== null
              ? String(rawHeader).trim()
              : '';
          if (headerStr && headerStr.toUpperCase() !== 'N/A') {
            if (
              headerStr.startsWith('http://') ||
              headerStr.startsWith('https://') ||
              headerStr.startsWith('data:')
            ) {
              this.image = headerStr;
            } else {
              this.image =
                this.enclosuresService.buildFileExampleDownloadUrl(headerStr);
            }
          } else {
            this.image = this.defaultImage;
          }
          this.style = item.color;
          const direction = String(item.chrUbicacion || '').split(',');
          const location = direction.slice(-2).map((part) => part.trim()).filter(Boolean);
          this.state = location.join(', ') || 'Monterrey, N.L.';
        },
        (error) => {
          this.error = error;
        }
      );
    }
  }

  onImageError(event: Event): void {
    if (this.hasSetDefaultImage) {
      return;
    }
    const img = event?.target as HTMLImageElement | null;
    if (img && !img.src.endsWith(this.defaultImage)) {
      img.src = this.defaultImage;
    }
    this.image = this.defaultImage;
    this.hasSetDefaultImage = true;
  }

  closeLogout(): void {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
    localStorage.removeItem('User');
    localStorage.clear();
  }

  get userInitials(): string {
    const words = String(this.nameProfile || 'Parkit').trim().split(/\s+/).filter(Boolean);
    return words.slice(0, 2).map((word) => word.charAt(0)).join('').toUpperCase();
  }

  profile(): void {
    this.router.navigate(['/change-profile']);
  }

  password(): void {
    this.router.navigate(['/change-pass']);
  }

  onReturn(): void {
    this.router.navigate(['/']);
  }
}
